import { render, staticRenderFns } from "./UnsuccessfulReasons.vue?vue&type=template&id=5d92f5ee&"
import script from "./UnsuccessfulReasons.vue?vue&type=script&lang=js&"
export * from "./UnsuccessfulReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports